var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-min-max"},[_c('div',{staticClass:"filter-label",on:{"click":function($event){_vm.showOptions = !_vm.showOptions}}},[_c('div',[_vm._v(_vm._s(_vm.t('segments-filters-birthdays_of_month')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }